var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('h1',{staticClass:"text-h5 mb-6"},[_vm._v(_vm._s(_vm.$t('Parked Receipts')))]),_vm._v(" "),_c('parked-receipts-table',{attrs:{"include-search":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37895ec7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/receipts/Parked.vue
// module id = null
// module chunks = 